import {
    Component,
    Inject,
    Input,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Gallery } from "angular-gallery";
import { TrabajoService } from "app/main/apps/shared/services/rest/trabajo.service";

@Component({
    selector: "app-imagenes-oott",
    templateUrl: "./imagenes-oott.component.html",
    styleUrls: ["./imagenes-oott.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class ImagenesOOTTComponent implements OnInit {
    imagenes: SafeUrl[];
    config: any;
    constructor(
        public dialogRef: MatDialogRef<ImagenesOOTTComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { idsFotos: number[] },
        private trabajoSrvc: TrabajoService,
        private sanitizer: DomSanitizer,
        private gallery: Gallery
    ) {
        this.imagenes = [];
    }

    ngOnInit(): void {
        //console.log(this.data.idsFotos);
        this.imagenes = [];
        this.data.idsFotos.forEach((idFoto) => {
            this.trabajoSrvc
                .fetchImagenAvanceTrabajo(idFoto)
                .subscribe((foto) => {
                    const urlFoto = this.sanitizer.bypassSecurityTrustUrl(
                        window.URL.createObjectURL(foto)
                    );
                    this.imagenes.push(urlFoto);
                });
        });
    }

    showGallery(index: number) {
        let prop = {
            images: [],
            index,
        };
        this.imagenes.forEach((imagen) => {
            prop.images.push({ path: imagen });
        });
        this.gallery.load(prop);
    }
}
